import React from 'react';
import PropTypes from 'prop-types';

/**
 * Statuszeile der Session-Detailseite.
 *
 * War bis August 2026 eine eigene Karte mit `bg-surface shadow-sm` UND einem
 * eigenen `max-w-2xl mx-auto` — die dritte Breitenbegrenzung auf derselben
 * Seite (PageShell, SessionStatus, hier). Übereinander gelegt ergaben die drei
 * ein Band aus abgesetztem Grau quer durch den Inhalt, das mit dem restlichen
 * Seitengerüst nichts zu tun hatte.
 *
 * Zusätzlich stand hier das Thema ein zweites Mal: Der Seitenkopf trägt es seit
 * August 2026 als Titel. Übrig bleibt genau die eine Information, die der Kopf
 * NICHT liefert — läuft die Session schon, oder wartet sie noch?
 */
const SessionHeader = ({ hasValidParticipants }) => {
  const tone = hasValidParticipants ? 'bg-success' : 'bg-warning';

  return (
    <p className="flex items-center gap-2.5 text-sm font-medium text-foreground">
      <span className="relative flex h-2.5 w-2.5 shrink-0" aria-hidden="true">
        {/* Der Puls meldet den Zustand dreimal und ruht dann — keine
            Endlosschleife im Randblick (CD §7, Okt 2026). motion-reduce: die
            globale Regel in index.css deckt animate-ping nicht ab. */}
        <span className={`absolute inline-flex h-full w-full animate-ping [animation-iteration-count:3] rounded-full opacity-60 motion-reduce:animate-none ${tone}`} />
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${tone}`} />
      </span>
      {hasValidParticipants ? 'Aktive Lernsession' : 'Warte auf Teilnehmende'}
    </p>
  );
};

SessionHeader.propTypes = {
  hasValidParticipants: PropTypes.bool.isRequired
};

export default SessionHeader;
